import e from"react";import{SideImageWrapper as r,SideImageContainer as t}from"./styles.js";const m=({imageSrc:m})=>e.createElement(r,null,e.createElement(t,{src:m}));export{m as SideImage};
//# sourceMappingURL=index.js.map
